import { useLoaderData } from "@remix-run/react";
import { QuizWrapper } from "~/components/quiz/QuizWrapper";
import { quizStepLoader } from "~/utils/quiz/loaders/quiz-step-loader";

/* ===============================================
  WORKAROUND for Shopify HMAC validation error:

  The `authenticate.public.appProxy` call fails when this loader
  re-runs after a child route action completes, likely due to
  incorrect HMAC parameters in the reload request.

  The `shouldRevalidate` function below prevents this loader
  from re-running automatically after child actions, avoiding the error.

  CAUTION: This breaks standard Remix data refreshing for this layout route.
  If this route needs its own actions that update its UI,
  the `shouldRevalidate` logic must be modified to allow revalidation
  when this specific route's actions are involved.
=============================================== */
export const shouldRevalidate = ({
  currentUrl, // The current URL before the navigation/action
  nextUrl, // The URL after the navigation/action
  formMethod, // The method of the submission (GET, POST, etc.)
  formData, // The submitted FormData object
  defaultShouldRevalidate, // The default Remix decision
}) => {
  return false;
};

/** @type {import('@remix-run/node').LoaderFunction} */
export async function loader({ params, request }) {
  return quizStepLoader({ params, request });
}

/** @type {import('@remix-run/react').MetaFunction} */
export function meta({ data }) {
  return [{ title: `Firstleaf: Quiz Step: ${data.stepNumber}` }];
}

export default function QuizStepPage() {
  const { stepNumber, customerId, subscriptionStatus } = useLoaderData();

  return (
    <QuizWrapper
      step={stepNumber}
      customerId={customerId}
      subscriptionStatus={subscriptionStatus}
    />
  );
}
